export default "__VITE_ASSET__BNOXdwR0__"